<div class="statistics-mat-table" #TABLE>

  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef>년월</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.date}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="dept_name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>부서</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.dept_name}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="logistics_collect_area_name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>권역</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.logistics_collect_area_name}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="logistics_div">
      <mat-header-cell *matHeaderCellDef mat-sort-header>수거구분</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.logistics_div}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="count">
      <mat-header-cell *matHeaderCellDef mat-sort-header>수배송건</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.count | currencyMask}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="give_unit_count">
      <mat-header-cell *matHeaderCellDef mat-sort-header>물량(점)</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.give_unit_count | currencyMask}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="give_box_count">
      <mat-header-cell *matHeaderCellDef mat-sort-header>기부박스</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.give_box_count | currencyMask}}</mat-cell>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

</div>